import { Menu, Tooltip } from '@mantine/core'

import Tag from 'src/components/DataDisplay/Tag/Tag'
import IconUsers from 'src/icons/IconUsers'

interface IncludeAssignedEmployeeMenuProps {
  includeAssignedEmployee: boolean
  setIncludeAssignedEmployee: (value: boolean) => void
}

const IncludeAssignedEmployeeMenu = ({ 
  includeAssignedEmployee, 
  setIncludeAssignedEmployee 
}: IncludeAssignedEmployeeMenuProps) => {
  
  const getDisplay = () => {
    return includeAssignedEmployee ? 'Auto-assign enabled' : 'Auto-assign'
  }

  const options = [
    { label: 'Enable auto-assign', value: true, description: 'Automatically assign to the employee responsible for the applicant' },
    { label: 'Disable auto-assign', value: false, description: 'Only assign to manually selected assignees' },
  ]

  return (
    <Menu
      offset={6}
      width={280}
      position="bottom-start"
      classNames={{
        dropdown: 'rounded shadow-sm p-1',
        item: 'text-doubleNickel-gray-700 text-xs p-2',
      }}
    >
      <Tooltip 
        label={'Auto-assign to responsible employee'} 
        position="bottom-start" 
        className="text-xs"
        multiline
        w={200}
      >
        <Menu.Target>
          <div>
            <Tag 
              showCloseButton={false} 
              size="xs" 
              clickable
              className={includeAssignedEmployee ? 'bg-green-100 text-green-700' : ''}
            >
              <IconUsers className="h-3 w-3 fill-none stroke-doubleNickel-gray-700" />
              {getDisplay()}
            </Tag>
          </div>
        </Menu.Target>
      </Tooltip>

      <Menu.Dropdown>
        {options.map((option) => (
          <Menu.Item
            key={option.value.toString()}
            onClick={() => setIncludeAssignedEmployee(option.value)}
            className={includeAssignedEmployee === option.value ? 'bg-doubleNickel-gray-100' : ''}
          >
            <div className="flex flex-col gap-1">
              <div className="font-medium">{option.label}</div>
              <div className="text-xs text-doubleNickel-gray-500 opacity-80">
                {option.description}
              </div>
            </div>
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  )
}

export default IncludeAssignedEmployeeMenu